// import the react components
import React, {useEffect} from "react";
import {BrowserRouter} from "react-router-dom";
import Navigation from "./components/navigation";
import SideBar from "./components/sidebar";
import Routers from "./components/routers";
import Loading from "./components/loading";
import SettingButton from "./ui/setting-button";
import SideSetting from "./components/side-setting";
import {useStateContext} from "./context/";
import useAuth from "./context/auth";
import ScrollToTop from "./context/scroll-to-top";
import "./assets/styles/app.css";

// the app functional based component
const App = () => {
    const {auth} = useAuth();
    const {active_menu, is_loading, theme_mode} = useStateContext();

    // remove the init content
    useEffect(() => {
        const init = document.querySelector("#init") || null;
        init !== null && init.remove();
    }, []);

    return (
        <div className={`${theme_mode === "dark" ? "dark" : ""}`}>
            <BrowserRouter>
                <ScrollToTop />

                <div className="flex relative dark:bg-main-dark-bg">
                    {is_loading && <Loading />}

                    {auth && <div className={`dark:bg-secondary-dark-bg transition-all delay-75 fixed bg-white shadow-lg ${active_menu ? "w-72" : "w-0"}`}>
                        <SideBar />
                    </div>}

                    <div className={`dark:bg-main-dark-bg bg-main-bg min-h-screen w-full transition-all delay-75 ${active_menu ? "md:ml-72" : "flex-2"}`}>
                        {auth && <Navigation />}

                        <div className="m-5">
                            <SettingButton />
                            <SideSetting />
                            <Routers />
                        </div>
                    </div>
                </div>
            </BrowserRouter>
        </div>
    );
};
export default App;